<template>
    <common-modal width="wide" @emitEvent="emitEvent($event, ['close'])" @close="close()" @continue="onContinue()">
        <common-content-spacer :isCenter="true" height="huge">
            <common-content-spacer height="small">
                <common-page-header
                    :isCenter="true"
                    :heading="$t('pages.referrals.new.steps.schedule.warning_24h.heading')"
                    size="minor"
                ></common-page-header>

                <common-page-copy :isCenter="true" size="major">
                    {{
                        $t('pages.referrals.new.steps.schedule.warning_24h.please_call', {
                            physician: composeDisplayName(physician),
                        })
                    }}
                </common-page-copy>
            </common-content-spacer>

            <schedule-physician
                v-if="practice.practiceType === PracticeTypeEnum.PHYSICIAN"
                :physician="physician"
            ></schedule-physician>
            <schedule-practice
                v-if="practice.practiceType === PracticeTypeEnum.ANCILLARY"
                :practice="practice"
            ></schedule-practice>

            <common-button
                :label="$t('pages.referrals.new.steps.schedule.warning_24h.continue')"
                type="primary"
                size="large"
                @click="onContinue()"
            ></common-button>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import { composeDisplayName } from 'components/common/CommonUserName'
    import SchedulePhysician from 'components/page-elements/referrals-new-schedule/SchedulePhysician'
    import SchedulePractice from 'components/page-elements/referrals-new-schedule/SchedulePractice'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            SchedulePhysician,
            SchedulePractice,
        },

        props: {
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
        },

        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        methods: {
            composeDisplayName,

            close() {
                this.emitEvent({ name: 'close' })
            },
            onContinue() {
                this.emitEvent({ name: 'continue' })
            },
        },
    }
</script>
